document.querySelectorAll('.language-toggle').forEach((toggle) => {
  toggle.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-lang-code]');
    if (!btn || btn.disabled) return;

    const form = btn.closest('form');
    const input = form?.querySelector('input[name="locale_code"]');
    if (!form || !input) return;

    input.value = btn.dataset.langCode;
    form.submit();
  });
});